import Vue from 'vue'
import { createImage} from '~image'
import NuxtImg from '~image/components/nuxt-img.vue'
import NuxtPicture from '~image/components/nuxt-picture.vue'

import * as staticRuntime$da72 from '/usr/src/app/node_modules/@nuxt/image/dist/runtime/providers/static.js'
import * as twicpicsRuntime$d345 from '/usr/src/app/node_modules/@nuxt/image/dist/runtime/providers/twicpics.js'
import * as ipxRuntime$2d65 from '/usr/src/app/node_modules/@nuxt/image/dist/runtime/providers/ipx.js'
import * as twicpicscustomRuntime$de10 from '/usr/src/app/providers/twicPicsCustom.js'

const imageOptions = {
  "screens": {
    "xs": 576,
    "sm": 768,
    "md": 996,
    "lg": 1200,
    "xl": 1367,
    "xxl": 1600,
    "2xl": 1536,
    "default": 320,
    "xxs": 480,
    "4k": 1921
  },
  "presets": {},
  "provider": "ipx",
  "domains": [
    "media.cving.com",
    "s3.gcp.cving.com",
    "s3.gcpstaging.cving.com",
    "s3.cving.com",
    "maps.googleapis.com",
    "localhost",
    "gcpstaging.cving.com",
    "local.cving.com",
    "curatorio.s3.amazonaws.com",
    "curator-assets.b-cdn.net"
  ],
  "alias": {}
}

imageOptions.providers = {
  ['static']: { provider: staticRuntime$da72, defaults: {} },
  ['twicpics']: { provider: twicpicsRuntime$d345, defaults: {"baseURL":"https://cvingdevstaging.twic.pics/"} },
  ['ipx']: { provider: ipxRuntime$2d65, defaults: {} },
  ['twicpicscustom']: { provider: twicpicscustomRuntime$de10, defaults: {"baseURL":"https://cvingdevstaging.twic.pics/"} }
}

Vue.component(NuxtImg.name, NuxtImg)
Vue.component(NuxtPicture.name, NuxtPicture)
Vue.component('NImg', NuxtImg)
Vue.component('NPicture', NuxtPicture)

export default function (nuxtContext, inject) {
  const $img = createImage(imageOptions, nuxtContext)

  if (process.static && process.server) {
    nuxtContext.beforeNuxtRender(({ nuxtState }) => {
      const ssrData = nuxtState.data[0] || {}
      ssrData._img = nuxtState._img || {}
    })
  }

  inject('img', $img)
}
